<div [class.chart-js-wrapper]="!dynamicHeight">
  <canvas #barChart></canvas>
</div>
